const api = {
  // 前端部署大屏需要相对路径
  login: '/api/login',
  getProject: '/api/ListCompanyProjectTree',
  projectCrane: '/api/ListProjectCrane',
  getSingleProject: '/api/DescribeProject',
  getConfig: '/api/config/project',
  getDayStaticData: '/api/ListDailySubStat',
  getRealData: '/api/ListRealtimeStat',
  getRunData: '/api/ListProjectCraneRealtimeMetric',
  getBoxData: '/elec/metric/boxes',
  getBoxInfo: '/elec/v2/box',
  getBoxMetric: '/elec/metric/box',
  refreshToken: '/api/refreshToken',
  projectPicture: '/api/config/project/picture',
  getYSToken: '/api/ezviz/getToken',

  // electron大屏需要全路径
  // login: 'http://t3.isafe360.com/api/login',
  // projects: 'http://t3.isafe360.com/api/ListProject',
  // getSingleProject: 'http://t3.isafe360.com/api/DescribeProject',
  // getConfig: 'http://t3.isafe360.com/api/config/project',
  // getDayStaticData: 'http://t3.isafe360.com/api/ListDailySubStat',
  // getRealData: 'http://t3.isafe360.com/api/ListRealtimeStat',
  // getRunData: 'http://t3.isafe360.com/api/ListProjectCraneRealtimeMetric',
  // getVideoUrl: 'http://t3.isafe360.com/api/VideoManager'
}
export default api



// WEBPACK FOOTER //
// ./src/api/index.js